import Phaser from 'phaser';

import { ChipViewModel } from './chip-view-model';
import { ResizeMetrics } from '../../../model/resize-metrics';

export class ChipView extends Phaser.GameObjects.Container {
  public get chipId(): string {
    return this.viewModel.chipId;
  }
  public get jitterOffset(): { x: number; y: number; angle: number } {
    return this.viewModel.jitterOffset;
  }

  private chip: Phaser.GameObjects.Image;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    private viewModel: ChipViewModel,
  ) {
    super(scene, x, y);

    this.chip = scene.add.image(0, 0, viewModel.chipAsset.type).setOrigin(0.5, 0.5);
    this.add(this.chip);

    this.setName(ChipView.name);
    scene.add.existing(this);
  }

  public onResize(resizeMetrics: ResizeMetrics) {
    const scalingMetrics = resizeMetrics.scalingMetrics;

    const buttonScale = 0.8;
    const width =
      this.viewModel.chipAsset.dimensions.width * scalingMetrics.scaleFactor * buttonScale;
    const height =
      this.viewModel.chipAsset.dimensions.height * scalingMetrics.scaleFactor * buttonScale;

    this.setSize(width, height);

    const graphicsScale = 0.8;
    this.chip.setDisplaySize(width * graphicsScale, height * graphicsScale);
  }
}
